<footer class="app-footer">
  <span>{{ 'footer.copyright' | translate: { year: year } }}</span>
</footer>
